import {
  ArrowLeftOutlined,
  BankOutlined,
  RightOutlined,
} from "@ant-design/icons";
import {
  AutoComplete,
  Avatar,
  Button,
  Card,
  Checkbox,
  Divider,
  Empty,
  notification,
  PageHeader,
  Typography,
} from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { translation } from "../../../../i18n/translationConstant";
import FIPModel from "../../../../Models/FIPModel";
import { GetFIPRequest } from "../../../../Models/Request/FIP/GetAllFIP";
import { AddIdentifier } from "../../../../Models/Request/Identifier/AddIdentifier";
import AccountLinkConfirmationResponse, {
  AccountLinkConfirmation,
} from "../../../../Models/Response/Account/AccountLink";
import DiscoverAccountResponse, {
  DiscoverAccountObject,
} from "../../../../Models/Response/Account/DiscoverAccount";
import { getFIP } from "../../../../redux/actions";
import store from "../../../../redux/store";
import {
  discoverAccounts,
  linkAccounts,
  linkAccountVerification,
} from "../../../../Services/AccountsServices/AccountService";
import { getFips } from "../../../../Services/FipServices/FipServices";
import { QueryParams, Routes } from "../../../../Utils/Constants/routes";
import LoginSignupSidePanel from "../../../Authentication/Components/Greetings";
import OTPInputComponent from "../../../Common/Components/OTPModal";
import PinInputComponent from "../../../Common/Components/PinInput";
import Identifiers from "../../../Identifiers";
import EMPTY_STATE from "../../../../Assets/empty_state.png";
import "./index.css";
import CommonModal from "../../../Common/Components/CommonModal";
import { LinkAccountModal } from "../../../../Assets/icons";
import FeedbackModal from "../../../Common/Components/FeedbackModal";
import { EntityIdentifier } from "../../../../Models/Request/Identifier/EntityIdentifier";
import { useFingerprintValidation } from "../../../Authentication/FingerprintValidationContext";
import { IdentifierCategory } from "../../../../Utils/Constants/identifierType";

interface ILinkAccountsProps {
  storeFIP: (res: GetFIPRequest) => void;
  fip: FIPModel[];
  fipListToBeShown: FIPModel[];
}


export enum FiCategories {
  INSURANCE = "Insurance",
  INVESTMENTS = "Investments",
  BANK = "Bank",
  TAX = "TAX",
  PENSION = "Pension",
  EQUITIES = "Equities",
  MUTUAL_FUNDS = "Mutual Funds",
  OTHERS = "Others"
}


const LinkAccounts: React.FC<ILinkAccountsProps> = ({ storeFIP, fip }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [fipListToBeShown, setFipListToBeShown] = useState(
    new Array<FIPModel>()
  );
  const [fipEntityIdentifiers, setFipEntityIdentifiers] = useState<
    EntityIdentifier[]
  >([]);

  const [currentFip, setCurrentFip] = useState({
    id: "",
    name: "",
    host: "",
    logoUrl: "",
    version: "",
    fipDescription: "",
  });
  const [selectedAccounts, setSelectedAccounts] = useState(new Array<string>());
  const [isOTPModalVisible, setIsOTPModalVisible] = useState(false);
  const [identifiers, setIdentifiers] = useState(new Array<AddIdentifier>());
  const [signature, setSignature] = useState("");
  const [refNumber, setRefNumber] = useState("");
  const [step, setStep] = useState(0);
  const [otp, setOtp] = useState("");
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
  const [accountLinked, setAccountedLinked] = useState(false);
  const [visible, setVisibility] = useState(false);
  const [discVisible, setDiscVisibility] = useState(false);

  const [discoverAccountsList, storeDiscoverAccounts] = useState<
    DiscoverAccountObject[]
  >([]);
  const useQuery = () => {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  };
  const query: any = useQuery();

  const {checkFingerprint} = useFingerprintValidation();

  useEffect(() => {
    setFipListToBeShown(fip);
    checkFingerprint();
  }, [fip, checkFingerprint]);


  useEffect(() => {
    getFips()
      .then((res) => res.data)
      .then((res: GetFIPRequest) => storeFIP(res));
  }, [storeFIP]);

  const resetDiscovery = () => {
    setDiscVisibility(false);
    storeDiscoverAccounts([]);
    setSelectedAccounts([]);
  };

  const onFIPSelect = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    setDiscVisibility(false);
    setCurrentFip(fipListToBeShown[parseInt(event.currentTarget.id, 10)]);
    setFipEntityIdentifiers(
      fipListToBeShown[parseInt(event.currentTarget.id, 10)].entityIdentifier
    );
    console.log("fipEntityIdentifiers", fipEntityIdentifiers);
    setStep(step + 1);
    setFipListToBeShown(fip);
  };

  // useEffect(() => {
  //   console.log(fipEntityIdentifiers);
  // }, [fipEntityIdentifiers]);

  const onAccountsSelect = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    // selectedAccounts.includes(event.currentTarget.id) ? selectedAccounts.re
    if (selectedAccounts.includes(event.currentTarget.id)) {
      setSelectedAccounts(
        selectedAccounts.filter((item) => item !== event.currentTarget.id)
      );
    } else {
      const accounts = [...selectedAccounts];
      accounts.push(event.currentTarget.id);
      setSelectedAccounts(accounts);
    }
  };

  const confirmLinkAccount = () => {
    linkAccounts({
      FipId: currentFip.id,
      Accounts: discoverAccountsList.filter(
        (_account, index) =>
          selectedAccounts.filter((value) => value === index.toString())[0]
      ),
      signature,
    })
      .then((res) => res.data)
      .then((_res: AccountLinkConfirmationResponse) => {
        setIsConfirmModalVisible(false);

        setIsOTPModalVisible(true);
        setRefNumber(_res.refNumber);
      });
  };

  const linkAccount = () => {
    setIsConfirmModalVisible(true);
  };

  const onLinkAccountOtp = () => {
    linkAccountVerification(refNumber, otp, currentFip.id)
      .then((res) => res.data)
      .then((_res: AccountLinkConfirmation) => {
        setIsOTPModalVisible(false);
        setSelectedAccounts([]);
        setCurrentFip({
          id: "",
          name: "",
          host: "",
          logoUrl: "",
          version: "",
          fipDescription: "",
        });

        setAccountedLinked(true);
      });
  };

  const onCancel = () => {
    setIsOTPModalVisible(false);
    setOtp("");
  };

  const setModalVisibility = () => {
    setVisibility(true);
  };

  const setDiscoverVisibility = () => {
    setDiscVisibility(true);
  };

  const closeModalVisibility = () => {
    setVisibility(false);
  };

  const discoverAccountWithIdentifiers = (identifierTem : AddIdentifier[]) => {

    const strongIdentifiers = identifierTem.filter(
      (identifier) => identifier.categoryType === IdentifierCategory.STRONG
    );

    const weakIdentifiers = identifierTem.filter(
      (identifier) => identifier.categoryType === IdentifierCategory.WEAK
    );

    const hasEmptyStrongIdentifier = strongIdentifiers.some(
      (identifier) => !identifier.value || identifier.value.trim() === ""
    );

    const hasWeakIdentifier = weakIdentifiers.length > 0;

    const hasFilledWeakIdentifier = weakIdentifiers.some(
      (identifier) => identifier.value && identifier.value.trim() !== ""
    );

    if (hasEmptyStrongIdentifier) {
      notification.info({
        message: t(translation.lblIncompleteIdentifiers),
        description: t(translation.lblPleaseAddIdentifiers),
      });
      return;
    }

    if (hasWeakIdentifier && !hasFilledWeakIdentifier) {
      notification.info({
        message: t(translation.lblIncompleteIdentifiers),
        description: t(translation.lblPleaseAddIdentifiers),
      });
      return;
    }

    setDiscVisibility(true);
    // setStep(step + 1);
    discoverAccounts({
      FITypes: ["GSTR1_3B"],
      FipId: currentFip.id,
      Identifiers: identifierTem,
    })
      .then((res) => res.data)
      .then((res: DiscoverAccountResponse) => {
        storeDiscoverAccounts(res.DiscoveredAccounts);
        setSignature(res.signature);
        setSelectedAccounts([]);
      })
      .catch(() => {
        //  goBack();
        // setModalVisibility();
        // setDiscVisibility(false); 
        // setStep(step - 1);
        setSelectedAccounts([]);
        storeDiscoverAccounts([]);
      });
  };

  // const discoverAccountWithIdentifiers = (identifierTem: AddIdentifier[]) => {
  //   // Move to step 1 (FIP details + identifiers)
  //   setStep(1);

  //   discoverAccounts({
  //     FITypes: ["GSTR1_3B"],
  //     FipId: currentFip.id,
  //     Identifiers: identifierTem,
  //   })
  //     .then((res) => res.data)
  //     .then((res: DiscoverAccountResponse) => {
  //       storeDiscoverAccounts(res.DiscoveredAccounts);
  //       setSignature(res.signature);
  //       setSelectedAccounts([]);
  //     })
  //     .catch(() => {
  //       // Stay on identifiers screen, just clear accounts
  //       setSelectedAccounts([]);
  //       storeDiscoverAccounts([]);
  //     });
  // };


  const pushToAccount = () => {
    history.push(Routes.account);
  };

  const onSearchValueChange = (value: string) => {
    setFipListToBeShown(
      value
        ? fip.filter(
            (p) => p.name.toUpperCase().indexOf(value.toUpperCase()) !== -1
          )
        : fip
    );
  };

  const location = useLocation<{ from?: string }>();
  const goBack = () => {
    if (step === 0) {
      //history.push(Routes.account);
      
      if (location.state?.from) {
        history.push(location.state.from);
      } else {
        history.push(Routes.account);
      }
    } else{
      setDiscVisibility(false);
      console.log("Going back from step:", step);
      setStep(step - 1);
      setSelectedAccounts([]);
      storeDiscoverAccounts([]);
    }
  };

  const onRadioSelect = (e: any) => {
    setIdentifiers(e);
  };

  const memoizedCallback = useCallback(onRadioSelect, []);

  const linkAccountSuccess = () => {
    const redirectPath = localStorage.getItem("redirectAfterAccountLink");
    if (redirectPath) {
      history.push(redirectPath);
    } else {
      history.push(Routes.account);
    }
  };

  // const renderStep = () => {
  //   return step === 0 ? (
  //     // THIS is LIST OF FIP SCREEN
  //     <div className="fipListScreen">
  //       {/* <Typography.Text className="linkAccountToAATypo">
  //         {t("Link your bank account to INK-AA")}
  //       </Typography.Text> */}
  //       <div className="fipCardList">
  //         <div className="fipListContainer ">
  //           {fipListToBeShown &&
  //             fipListToBeShown.map((FIP: FIPModel, index) => (
  //               <div className="fipListItem" key={index}>
  //                 <Card
  //                   key={index}
  //                   className="linkAccountCard"
  //                   id={index.toString()}
  //                   hoverable={false}
  //                   onClick={
  //                     FIP.fipDescription != "Coming Soon"
  //                       ? onFIPSelect
  //                       : undefined
  //                   }
  //                   // onClick={onFIPSelect}
  //                   bordered={false}
  //                 >
  //                   {FIP.logoUrl != "" ? (
  //                     <div className="fipLogo">
  //                       <img src={FIP.logoUrl} alt="" />
  //                     </div>
  //                   ) : (
  //                     <div className="fipLogo">
  //                       {/* <BankOutlined style={{ fontSize: "2.5em", alignContent: 'center', alignItems: 'center' }} /> */}
  //                     </div>
  //                   )}
  //                   <div className="cardContent">
  //                     <Typography.Text className="cardContentFIPTitle">
  //                       {FIP.name}
  //                     </Typography.Text>
  //                     <Typography.Text className="cardContentFIPSubTitle">
  //                       {FIP.fipDescription}
  //                     </Typography.Text>
  //                   </div>
  //                   <RightOutlined className="checkOutlined" onPointerOverCapture={undefined} onPointerMoveCapture={undefined} />
  //                 </Card>
  //                 <Divider className="accountDivider" />
  //               </div>
  //             ))}
  //         </div>
  //       </div>

  //       <Button
  //         type="text"
  //         className="commonButtonBackground skipButton"
  //         // style={{ fontSize: 20}}
  //         onClick={pushToAccount}
  //       >
  //         {t(translation.lblSkip)}
  //       </Button>
  //     </div>
  //   ) : (
  //     // THIS IS FIP DETAILS SCREEN
  //     <>
  //       <Typography.Text className="fontSize18FontWeight500">
  //         {t(translation.lblIdentifiersFirst)}{" "}
  //         <Typography.Text className="moreItemIcons fontSize18FontWeight500">
  //           {currentFip.name}
  //         </Typography.Text>{" "}
  //         {t(translation.accounts)}{" "}
  //         <Typography.Text className="fipDescriptionDiv fontSize18FontWeight500">
  //           {currentFip.fipDescription}{" "}
  //         </Typography.Text>
  //       </Typography.Text>

  //       <div className="linkAccountFipDetailBody">
  //         {/* 
  //         Below Identifiers Widget contains list of Identifiers
  //         as well as Add Identifier and Discover Accounts Button
  //       */}
  //         {!discVisible ? (
  //           <Identifiers //TODO data persistant for all 3 steps
  //             onRadioSelect={memoizedCallback}
  //             onSelectIdentifier={discoverAccountWithIdentifiers}
  //             modalVisibility={visible}
  //             fipEntityIdentifiers={fipEntityIdentifiers}
  //             onCloseModal={closeModalVisibility}
  //           />
  //         ) : /* {<Divider  className="vertical-divider" /> }*/
  //         /* {<span className="vertical-divider"> </span> }*/

  //         discoverAccountsList && discoverAccountsList.length ? (
  //           <div className="linkAccountBody">
  //             <div className="discoverAccounts">
  //               {discoverAccountsList && discoverAccountsList.length ? (
  //                 discoverAccountsList.map((accounts, index) => (
  //                   <Card
  //                     key={index}
  //                     className="discoverAccountCard"
  //                     id={index.toString()}
  //                     hoverable={false}
  //                     onClick={onAccountsSelect}
  //                   >
  //                     <Avatar
  //                       className="consentAvatar"
  //                       src={currentFip.logoUrl}
  //                     />
  //                     <div className="accountInfo">
  //                       <Typography.Text className="accountCardFIP">
  //                         {currentFip && currentFip.name}
  //                       </Typography.Text>
  //                       <br />
  //                       <div>
  //                         <Typography.Text className="accountCardNumber">
  //                           {accounts.maskedAccNumber}
  //                         </Typography.Text>
  //                         <Divider type="vertical" />
  //                         <Typography.Text className="accountCardAccountType">
  //                           {accounts.accType}
  //                         </Typography.Text>
  //                         <Divider type="vertical" />
  //                         <Typography.Text className="accountCardAccountType">
  //                           {accounts.FIType}
  //                         </Typography.Text>
  //                       </div>
  //                     </div>

  //                     <Checkbox
  //                       checked={selectedAccounts.includes(index.toString())}
  //                       className="checkBoxAccount"
  //                     />
  //                   </Card>
  //                 ))
  //               ) : (
  //                 <Empty
  //                   className="emptyTag"
  //                   image={EMPTY_STATE}
  //                   description={
  //                     <Typography.Text className="noAccountFound">
  //                       {t(translation.errorNoAccountsFound)}
  //                     </Typography.Text>
  //                   }
  //                 />
  //               )}
  //             </div>
  //             <div className="linkAccountButton">
  //               <Button
  //                 disabled={selectedAccounts.length ? false : true}
  //                 className="commonButtonBackground primaryButton linkAccountNoAccounts"
  //                 onClick={linkAccount}
  //               >
  //                 {t(translation.lblLinkAccount)}
  //               </Button>
  //             </div>
  //           </div>
  //         ) : (
  //           <></>
  //         )}
  //       </div>
  //     </>
  //   );
  // };

  const renderStep = () => {
    return step === 0 ? (
      <div className="fipListScreen">
        <div className="fipCardList">
          <div className="fipListContainer">
            {fipListToBeShown && fipListToBeShown.length > 0 ? (
              fipListToBeShown.map((FIP: FIPModel, index) => (
                <div className="fipListItem" key={index}>
                  <Card
                    className="linkAccountCard"
                    id={index.toString()}
                    hoverable={false}
                    onClick={
                      FIP.fipDescription !== "Coming Soon"
                        ? onFIPSelect
                        : undefined
                    }
                    bordered={false}
                  >
                    <div className="fipLogo">
                      {FIP.logoUrl ? (
                        <img src={FIP.logoUrl} alt={`${FIP.name} logo`} />
                      ) : (
                        <BankOutlined className="bankIcon"/>
                      )}
                    </div>
                    <div className="cardContent">
                      <Typography.Text className="cardContentFIPTitle">
                        <strong>{FIP.name}</strong>
                      </Typography.Text>
                      <Typography.Text className="cardContentFIPSubTitle">
                        {FIP.fipDescription}
                      </Typography.Text>
                    </div>
                    <RightOutlined className="checkOutlined" />
                  </Card>
                </div>
              ))
            ) : (
              <Empty
                description={
                  <Typography.Text className="noFipFound">
                    {t(translation.lblNoFipsFound)}
                  </Typography.Text>
                }
              />
            )}
          </div>
        </div>
      </div>
    ) : (
      <div className="identifierPage">
        <div className="identifierStepper" aria-label={t(translation.lblLinkAccountProgress)}>
          <div className="stepItem active">
            <span className="stepCircle">1</span>
            <span>{t(translation.lblEnterIdentifiers)}</span>
          </div>
          <div className="stepLine" />
          <div className={`stepItem ${discoverAccountsList.length ? "active" : ""}`}>
            <span className="stepCircle">2</span>
            <span>{t(translation.lblFindAccounts)}</span>
          </div>
          <div className="stepLine" />
          <div className="stepItem">
            <span className="stepCircle">3</span>
            <span>{t(translation.lblReviewConsent)}</span>
          </div>
          <div className="stepLine" />
          <div className="stepItem">
            <span className="stepCircle">4</span>
            <span>{t(translation.lblAccountLinked)}</span>
          </div>
        </div>

        <div className="selectedFipBanner">
          <div className="selectedFipIdentity">
            <div className="selectedFipLogo">
              {currentFip.logoUrl ? (
                <img src={currentFip.logoUrl} alt={`${currentFip.name} logo`} />
              ) : (
                <BankOutlined />
              )}
            </div>
            <div>
              <div className="selectedFipName">{currentFip.name}</div>
              <div className="selectedFipTags">
                <span>{t(translation.lblBanking)}</span>
                <span>{t(translation.lblRbiRegisteredFip)}</span>
              </div>
            </div>
          </div>
          <div className="selectedFipAssurance">
            <div className="assuranceItem">
              <span className="assuranceIcon">✓</span>
              <div><strong>{t(translation.lblSecureAndEncrypted)}</strong><small>{t(translation.lblRbiRegulated)}</small></div>
            </div>
            <div className="assuranceDivider" />
            <div className="assuranceItem">
              <span className="assuranceIcon">▣</span>
              <div><strong>{t(translation.lblYourDataIsSafe)}</strong><small>{t(translation.lblWeDoNotStoreData)}</small></div>
            </div>
          </div>
        </div>

        <div className="identifierWorkspace">
          <div className="identifierPanel">
            <Identifiers
              onRadioSelect={memoizedCallback}
              onSelectIdentifier={discoverAccountWithIdentifiers}
              modalVisibility={visible}
              fipEntityIdentifiers={fipEntityIdentifiers}
              onCloseModal={closeModalVisibility}
              onOpenModal={setModalVisibility}
              onIdentifierChange={resetDiscovery}
            />
          </div>

          <div className="accountsFoundPanel">
            <div className="accountsFoundHeader">
              <Typography.Title level={3}>
                {t(translation.lblAccountsFound)} ({discoverAccountsList.length})
              </Typography.Title>
              <Typography.Text>
                {t(translation.lblSelectAccountsToLink)}
              </Typography.Text>
            </div>

            {discoverAccountsList.length > 0 ? (
              <div className="discoverAccounts">
                {discoverAccountsList.map((accounts, index) => (
                  <Card
                    key={index}
                    className={`discoverAccountCard ${selectedAccounts.includes(index.toString()) ? "selected" : ""}`}
                    id={index.toString()}
                    hoverable={false}
                    onClick={onAccountsSelect}
                  >
                    <Checkbox
                      checked={selectedAccounts.includes(index.toString())}
                      className="checkBoxAccount"
                    />
                    <div className="discoverAccountIcon">
                      {currentFip.logoUrl ? (
                        <img src={currentFip.logoUrl} alt="" />
                      ) : (
                        <BankOutlined />
                      )}
                    </div>
                    <div className="accountInfo">
                      <Typography.Text className="accountCardFIP">
                        {accounts.accType || t(translation.lblAccount)}
                      </Typography.Text>
                      <Typography.Text className="accountCardNumber">
                        {accounts.maskedAccNumber}
                      </Typography.Text>
                    </div>
                    <span className="accountTypePill">{accounts.FIType || accounts.accType}</span>
                    <RightOutlined className="accountArrow" />
                  </Card>
                ))}
              </div>
            ) : (
              <div className="accountsFoundEmpty">
                <BankOutlined />
                <strong>{t(translation.lblNoAccountsFoundYet)}</strong>
                <span>{t(translation.lblEnterIdentifiersAndContinue)}</span>
              </div>
            )}
          </div>
        </div>

        <div className="identifierFooter">
          <Button className="identifierCancelButton" onClick={goBack}>{t(translation.lblCancel)}</Button>
          <div className="identifierFooterRight">
            <span>{selectedAccounts.length} {selectedAccounts.length === 1 ? t(translation.lblAccountSelected) : t(translation.lblAccountsSelected)}</span>
            <Button
              type="primary"
              className="identifierContinueButton"
              disabled={discoverAccountsList.length > 0 && selectedAccounts.length === 0}
              onClick={() => {
                if (discoverAccountsList.length > 0) {
                  linkAccount();
                  return;
                }

                const buttons = document.querySelectorAll(
                  ".identifierPanel .actionButtonGroup button"
                );
                const button = buttons[buttons.length - 1] as HTMLButtonElement;
                if (button) button.click();
              }}
            >
              {t(translation.lblContinue)} <RightOutlined />
            </Button>
          </div>
        </div>
      </div>
    );
  };

  const [selectedCategory, setSelectedCategory] = useState<FiCategories | null>(null);

  const filterFipsByCategory = (category: FiCategories) => {
    setSelectedCategory(category);
    console.log("Filtering FIPs by category:", category);
    console.log("All FIPs:", fip);

    if (category === FiCategories.INVESTMENTS) {
      setFipListToBeShown(
        fip.filter((p) =>
          [
            FiCategories.PENSION.toUpperCase(),
            FiCategories.EQUITIES.toUpperCase(),
            FiCategories.MUTUAL_FUNDS.toUpperCase()
          ].includes((p as any).group?.toUpperCase())
        )
      );
    }else{
      setFipListToBeShown(
        fip.filter(
          (p) => (p as any).group?.toUpperCase() === category.toString().toUpperCase()
        )
      );
    }
    
  };


  return (
    <>
      <OTPInputComponent
        onCancel={onCancel}
        isOpen={isOTPModalVisible}
        onOtpSubmit={onLinkAccountOtp}
        okText={t(translation.lblConfirm)}
        numInputs={6}
        title={t(translation.lblLinkAccount)}
        onResend={linkAccount}
        isOtpInputVisible={true}
        mobileNumber={
          identifiers
            .filter(
              (value) =>
                value.categoryType === "STRONG" && value.type === "MOBILE"
            )
            .map((value) => value.value)[0]
        }
      >
        <PinInputComponent
          className="pinInput"
          // tslint:disable-next-line: jsx-no-lambda
          onChange={(pin) => setOtp(pin)}
          maxLength={10}
          enterPressed={onLinkAccountOtp}
          label={t(translation.lblEnterOTP)}
        />
      </OTPInputComponent>

      <CommonModal
        onCancel={() => setIsConfirmModalVisible(false)}
        visible={isConfirmModalVisible}
      >
        <div className="linkAccountConfirmModal">
          <div className="linkAccountConfirmIcon">
            <LinkAccountModal />
          </div>

          <Typography.Text className="linkAccountConfirmTitle">
            {t(translation.lblLinkAccounts)}
          </Typography.Text>

          <Typography.Text className="linkAccountConfirmMessage">
            {t("msgLinkedAccounts")}
          </Typography.Text>

          <div className="linkAccountConfirmActions">
            <Button
              className="linkAccountConfirmCancel"
              onClick={() => setIsConfirmModalVisible(false)}
            >
              {t(translation.lblCancel)}
            </Button>

            <Button
              className="linkAccountConfirmSubmit"
              onClick={confirmLinkAccount}
            >
              {t(translation.lblLinkAccounts)}
            </Button>
          </div>
        </div>
      </CommonModal>

      {accountLinked ? (
        <FeedbackModal
          modalClose={linkAccountSuccess}
          message={t(translation.msgOtpVerifiedSuccessfully)}
          action={linkAccountSuccess}
          actionButtonText={t(translation.lblContinue)}
        ></FeedbackModal>
      ) : (
        <></>
      )}
      {/* 
          Below layout is for LINK ACCOUNT PAGE
          ~ Aryan
      */}
      <div className="linkAccountContainer">
        <div className="linkAccountSignForm flexCustomCss linkAccountRoot">
          {step === 0 ? (
            <div className="fipSelectionLegacyHeader">
              <ArrowLeftOutlined onClick={goBack} className="backIcon" /> 
              <div className="linkAccountTitle">{t(translation.lblLinkAccount)}</div>
              {/* <PageHeader
                className="linkAccountTitle"
                // backIcon={}
                onBack={goBack}
                title={t(translation.lblLinkAccount)}
              /> */}
            </div>
          ) : (
            <div className="identifierTopHeader">
              <div>
                {/* <button className="identifierBackButton" onClick={goBack}>
                  <ArrowLeftOutlined /> Back
                </button> */}
                <Typography.Title level={1}>{t(translation.lblLinkAccount)}</Typography.Title>
                <Typography.Text>
                  {t(translation.lblProvideIdentifiers)} {currentFip.name}.
                </Typography.Text>
              </div>
            </div>
          )}

          {step === 0 && (
            <>
              <AutoComplete
                className="autcomplete"
                allowClear={true}
                autoFocus={false}
                open={false}
                autoClearSearchValue={true}
                placeholder={t(translation.lblHomeSearch)}
                onChange={onSearchValueChange}
                size="large"
              />
              <div className="filterContainer">
                <Button type={selectedCategory === null ? "primary" : "default"} onClick={() => { setSelectedCategory(null); setFipListToBeShown(fip); }}>{t(translation.lblAll)}</Button>
                <Button type={selectedCategory === FiCategories.BANK ? "primary" : "default"} onClick={() => filterFipsByCategory(FiCategories.BANK)}>{t(translation.lblBanks)}</Button>
                <Button type={selectedCategory === FiCategories.INSURANCE ? "primary" : "default"} onClick={() => filterFipsByCategory(FiCategories.INSURANCE)}>{t(translation.lblInsurance)}</Button>
                <Button type={selectedCategory === FiCategories.INVESTMENTS ? "primary" : "default"} onClick={() => filterFipsByCategory(FiCategories.INVESTMENTS)}>{t(translation.lblInvestments)}</Button>
                <Button type={selectedCategory === FiCategories.TAX ? "primary" : "default"} onClick={() => filterFipsByCategory(FiCategories.TAX)}>{t(translation.lblGst)}</Button>
                <Button type={selectedCategory === FiCategories.MUTUAL_FUNDS ? "primary" : "default"} onClick={() => filterFipsByCategory(FiCategories.MUTUAL_FUNDS)}>{t(translation.lblMutualFunds)}</Button>
                <Button type={selectedCategory === FiCategories.PENSION ? "primary" : "default"} onClick={() => filterFipsByCategory(FiCategories.PENSION)}>{t(translation.lblPension)}</Button>
                <Button type={selectedCategory === FiCategories.OTHERS ? "primary" : "default"} onClick={() => filterFipsByCategory(FiCategories.OTHERS)}>{t(translation.lblOthers)}</Button>
              </div>
              <div className="alphabetFilterContainer">
                <Button type="default" onClick={() => setFipListToBeShown(fip)}>{t(translation.lblAll)}</Button>
                {Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i)).map((letter) => (
                  <Button key={letter} type="default" onClick={() => setFipListToBeShown(fip.filter((f) => f.name.toUpperCase().startsWith(letter)))}>{letter}</Button>
                ))}
              </div>
            </>
          )}

          {renderStep()}
        </div>
      </div>
    </>
  );
};

const storeFip = (res: GetFIPRequest) => store.dispatch(getFIP(res));

const mapDispatchToProps = () => {
  return {
    storeFIP: storeFip,
  };
};

const mapStateToProps = (state: any) => ({
  fip: state.fip.fips,
});

export default connect(mapStateToProps, mapDispatchToProps)(LinkAccounts);
function elseif(arg0: boolean) {
  throw new Error("Function not implemented.");
}

